export enum RatingSize {
  M = 'm',
  L = 'l',
}
